import React, { FC, useState } from 'react';

import { AppCol, AppRow } from 'components/appComponents';

import { DriverTransport, Transports } from './components';

const TransportPage: FC = () => {
  const [selectTransport, setSelectTransport] = useState<number | null>(null);

  return (
    <div className="container-dev">
      <AppRow>
        <AppCol col={8}>
          <Transports onChangeSelect={setSelectTransport} />
        </AppCol>
        <AppCol col={4}>{selectTransport && <DriverTransport transportId={selectTransport} />}</AppCol>
      </AppRow>
    </div>
  );
};

export default TransportPage;
